import 'babel-polyfill';
import 'react-app-polyfill/ie11';
import 'webfontloader';
import 'react-hot-loader/patch';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import { HashRouter } from 'react-router-dom';
import { AppContainer } from 'react-hot-loader';
import Shell from 'components/shell';
import store, { history } from './store';
import 'react-circular-progressbar/dist/styles.css';

import baseStyles from './assets/styles';

baseStyles();

const render = Component => {
  ReactDOM.render(
    <AppContainer>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <HashRouter>
            <Component />
          </HashRouter>
        </ConnectedRouter>
      </Provider>
    </AppContainer>,
    document.querySelector('#root')
  );
};

render(Shell);

if (module.hot) {
  module.hot.accept('components/shell', () => {
    /* eslint-disable global-require */
    const NextShell = require('components/shell').default;
    render(NextShell);
  });
}
if (process.env.NODE_ENV === 'development') {
  const a11y = require('react-a11y').default;
  a11y(React, ReactDOM, {
    rules: {
      'img-uses-alt': 'warn',
      'redundant-alt': ['warn', ['image', 'photo', 'foto', 'bild']],
      'label-uses-for': 'warn',
      'mouse-events-map-to-key-events': 'warn',
      'onclick-uses-role': 'warn',
      'button-role-space': 'warn',
      'hidden-uses-tabindex': 'warn',
      'no-access-key': 'warn',
      'no-hash-ref': 'warn',
      'no-unsupported-elements-use-aria': 'warn',
      'onclick-uses-tabindex': 'warn',
      'tabindex-uses-button': 'warn',
      'use-onblur-not-onchange': 'warn',
      'valid-aria-role': 'warn'
    }
  });
}
